<template>
  <div class="unit-page">
    <el-card class="tool-card" shadow="never">
      <div class="tool-row">
        <div class="tool-left">
          <span class="tool-title">战队管理</span>
          <span class="tool-sub">战队可独立登录账号，分为推广战队 / 销售战队</span>
        </div>
        <el-button type="primary" icon="el-icon-plus" @click="openEdit(null)">新增战队</el-button>
      </div>
    </el-card>

    <el-card class="table-card" shadow="never">
      <el-table
        v-loading="loading"
        :data="list"
        :header-cell-style="{ background: '#F7F9FC', color: '#18233C', fontWeight: 600 }"
        empty-text="暂无战队数据"
      >
        <el-table-column label="战队名称" min-width="150">
          <template slot-scope="{ row }">
            <div class="cell-name-main">
              <div class="cell-name-text">{{ row.name }}</div>
              <div class="cell-name-sub">{{ row.account }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="类型" min-width="100" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="parseInt(row.type) === 2 ? 'primary' : 'warning'" size="small">{{ row.type_text }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="联系人" prop="contact" min-width="90">
          <template slot-scope="{ row }">
            <span>{{ row.contact || '—' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="电话" prop="phone" min-width="120">
          <template slot-scope="{ row }">
            <span class="cell-time">{{ row.phone || '—' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="小组" min-width="70" align="center">
          <template slot-scope="{ row }">
            <span class="count-num">{{ row.team_count }}</span>
          </template>
        </el-table-column>
        <el-table-column label="员工" min-width="70" align="center">
          <template slot-scope="{ row }">
            <span class="count-num">{{ row.staff_count }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" min-width="80" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="parseInt(row.status) === 1 ? 'success' : 'info'" size="small">
              {{ parseInt(row.status) === 1 ? '启用' : '停用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" min-width="130">
          <template slot-scope="{ row }">
            <span class="cell-time">{{ fmtDate(row.createtime) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="130" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="openEdit(row)">编辑</el-button>
            <el-button type="text" size="small" class="del-btn" @click="doDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="editId ? '编辑战队' : '新增战队'" :visible.sync="editVisible" width="520px">
      <el-form ref="form" :model="form" :rules="rules" label-width="90px" size="small">
        <el-form-item label="登录账号" prop="account">
          <el-input v-model="form.account" placeholder="3-50 位字母数字下划线" :maxlength="50" :disabled="editId > 0" />
        </el-form-item>
        <el-form-item label="战队名称" prop="name">
          <el-input v-model="form.name" placeholder="如：销售一队" :maxlength="50" />
        </el-form-item>
        <el-form-item label="战队类型" prop="type">
          <el-radio-group v-model="form.type">
            <el-radio :label="1">推广战队</el-radio>
            <el-radio :label="2">销售战队</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="登录密码" prop="password">
          <el-input v-model="form.password" type="password" show-password :placeholder="editId ? '不修改请留空' : '请设置登录密码'" />
        </el-form-item>
        <el-form-item label="联系人">
          <el-input v-model="form.contact" :maxlength="50" />
        </el-form-item>
        <el-form-item label="电话">
          <el-input v-model="form.phone" :maxlength="20" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" :rows="2" :maxlength="200" />
        </el-form-item>
        <el-form-item label="状态">
          <el-switch v-model="form.status" active-text="启用" inactive-text="停用" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editVisible = false">取 消</el-button>
        <el-button type="primary" size="small" :loading="saving" @click="doSave">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { unitList, unitSave, unitDelete } from '@/api/org'

export default {
  name: 'UnitList',
  data() {
    return {
      list: [],
      loading: false,
      editVisible: false,
      editId: 0,
      saving: false,
      form: { account: '', name: '', type: 2, password: '', contact: '', phone: '', remark: '', status: true },
      rules: {
        account: [
          { required: true, message: '请填写登录账号', trigger: 'blur' },
          { pattern: /^[a-zA-Z0-9_]{3,50}$/, message: '3-50 位字母数字下划线', trigger: 'blur' }
        ],
        name: [{ required: true, message: '请填写战队名称', trigger: 'blur' }],
        password: [{ validator: (r, v, cb) => { if (this.editId === 0 && !v) cb(new Error('请设置登录密码')); else cb() }, trigger: 'blur' }]
      }
    }
  },
  created() {
    this.load()
  },
  methods: {
    load() {
      this.loading = true
      unitList()
        .then(data => { this.list = data.list || [] })
        .catch(() => { this.list = [] })
        .finally(() => { this.loading = false })
    },
    openEdit(row) {
      if (row) {
        this.editId = row.id
        this.form = {
          account: row.account,
          name: row.name,
          type: parseInt(row.type),
          password: '',
          contact: row.contact || '',
          phone: row.phone || '',
          remark: row.remark || '',
          status: parseInt(row.status) === 1
        }
      } else {
        this.editId = 0
        this.form = { account: '', name: '', type: 2, password: '', contact: '', phone: '', remark: '', status: true }
      }
      this.editVisible = true
    },
    doSave() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.saving = true
        unitSave({
          id: this.editId,
          account: this.form.account,
          name: this.form.name,
          type: this.form.type,
          password: this.form.password,
          contact: (this.form.contact || '').trim(),
          phone: (this.form.phone || '').trim(),
          remark: (this.form.remark || '').trim(),
          status: this.form.status ? 1 : 0
        })
          .then(() => {
            this.$message.success(this.editId ? '修改成功' : '新增成功')
            this.editVisible = false
            this.load()
          })
          .catch(() => {})
          .finally(() => { this.saving = false })
      })
    },
    doDelete(row) {
      this.$confirm(`确认删除战队「${row.name}」？`, '删除战队', {
        confirmButtonText: '删 除',
        cancelButtonText: '取 消',
        type: 'warning'
      }).then(() => {
        unitDelete(row.id)
          .then(() => {
            this.$message.success('删除成功')
            this.load()
          })
          .catch(() => {})
      }).catch(() => {})
    },
    fmtDate(ts) {
      if (!ts) return '—'
      const d = new Date(parseInt(ts) * 1000)
      const p = n => (n < 10 ? '0' + n : '' + n)
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`
    }
  }
}
</script>

<style scoped>
.unit-page { padding: 0; }

.tool-card {
  margin-bottom: 14px;
  border-radius: 10px;
  border: 1px solid #E5E9F2;
}

.tool-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
}

.tool-left { display: flex; align-items: baseline; gap: 12px; }

.tool-title { font-size: 15px; font-weight: 700; color: #18233C; }
.tool-sub { font-size: 12px; color: #8A94AD; }

.table-card {
  border-radius: 10px;
  border: 1px solid #E5E9F2;
}

.cell-name-main { min-width: 0; }

.cell-name-text {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #18233C;
}

.cell-name-sub {
  display: block;
  font-size: 11px;
  color: #8A94AD;
  margin-top: 2px;
  font-family: monospace;
}

.cell-time {
  font-size: 12px;
  color: #5A6580;
  font-variant-numeric: tabular-nums;
}

.count-num {
  font-size: 14px;
  font-weight: 600;
  color: #3668FC;
}

.del-btn { color: #E5484D; }

/* ===== Element UI 品牌色统一 ===== */
::v-deep .el-button--primary {
  background: #3668FC;
  border-color: #3668FC;
}

::v-deep .el-button--primary:hover,
::v-deep .el-button--primary:focus { background: #5B8DFF; border-color: #5B8DFF; }

::v-deep .el-table__row:hover > td {
  background: #F5F8FF !important;
}

::v-deep .el-dialog { border-radius: 12px; }
</style>
